import { Injectable, inject } from '@angular/core';
import { type MissingTranslationHandler, type MissingTranslationHandlerParams } from '@ngx-translate/core';
import { injectRumService } from '../services/rum/rum.service';
import { WindowReloadService } from '../services/window-reload/window-reload.service';

const RELOAD_GUARD_KEY = 'dpqa-missing-translation-reloaded';

@Injectable()
export class MissingTranslationReloadHandler implements MissingTranslationHandler {
  private rumService = injectRumService();
  private windowReloadService = inject(WindowReloadService);

  handle(params: MissingTranslationHandlerParams): string {
    this.rumService.awsRum()?.recordEvent('dpqa.missing-translation', {
      key: params.key,
    });

    this.reloadOnce();

    return params.key;
  }

  private reloadOnce(): void {
    if (window.sessionStorage.getItem(RELOAD_GUARD_KEY)) {
      return;
    }

    window.sessionStorage.setItem(RELOAD_GUARD_KEY, '1');
    this.windowReloadService.reload();
  }
}
